'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var jsonSchema_utils = require('./utils.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

/**
 * Fork from https://github.com/epoberezkin/json-schema-traverse/blob/master/index.js
 *
 * 根据规范只是新增了几个属性
 */

var noop = function noop() {};
var keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true,
  "if": true,
  then: true,
  "else": true
};
var arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};
function getPropsKeywords() {
  var _getAllExpendKeys = jsonSchema_utils.getAllExpendKeys(),
    expendRefsKey = _getAllExpendKeys.expendRefsKey,
    expendOverridesKey = _getAllExpendKeys.expendOverridesKey;
  return _defineProperty(_defineProperty({
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
  }, expendRefsKey, true), expendOverridesKey, true);
}
var skipKeywords = {
  "default": true,
  "enum": true,
  "const": true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};
function traverse(schema, opts, cb) {
  var pre = cb || noop;
  var options = {};
  var post = noop;
  if (typeof opts == 'function') {
    pre = opts;
    options = {};
  } else if (_typeof(opts) === 'object') {
    options = opts;
    if (typeof opts.cb === 'function') {
      pre = opts.cb;
    } else if (_typeof(opts.cb) === 'object') {
      pre = opts.cb.pre || noop;
      post = opts.cb.post || noop;
    }
  }
  traverseCore(options, pre, post, schema, '', schema);
}
function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}
function traverseCore(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  var propsKeywords = getPropsKeywords();
  if (schema && _typeof(schema) == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in arrayKeywords) {
          for (var i = 0; i < sch.length; i++) traverseCore(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in propsKeywords) {
        if (sch && _typeof(sch) == 'object') {
          for (var prop in sch) traverseCore(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in keywords || opts.allKeys && !(key in skipKeywords)) {
        traverseCore(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}
exports.default = traverse;
